module.exports = __webpack_public_path__ + "img/nino-juguete.b9a811b5.jpg";